export default __webpack_public_path__ + "static/media/pizza.29203363.jpg";